import { ApplicationRootState } from 'redux-core/types';
import { createSelector } from 'reselect';
import { initialState } from './reducer';

const selectAdminRolePermission = (state: ApplicationRootState) =>
    state.admin.rolePermission || initialState;

export const selectRolePermissionList = createSelector(
    selectAdminRolePermission,
    (state) => state.list
);
